// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gjhGGhx3g4Io3jv1I4vP{flex-direction:column;gap:13px;display:flex}.qBgxARLwbcAsyGfaDFi2{padding-left:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `gjhGGhx3g4Io3jv1I4vP`,
	"textField": `qBgxARLwbcAsyGfaDFi2`
};
export default ___CSS_LOADER_EXPORT___;
